export default __webpack_public_path__ + "static/media/copy-blue.085b28ea.svg";